<template>
    <p-search-screen
        ref="searchScreen"
        title="Terms"
        api-destination="terms"
        edit-key="termId"
        :filters="filters"
        :filterBy="filterBy"
        :fields="fields"
        add-new-button
    >        
        <template v-slot:actionButtons>
            <p-button
                variant="btn btn-outline-primary"
                @click="showAuthorList()"
                >Author List</p-button
            >
            <AuthorListReport ref="authorList" />
        </template>
        <template v-slot:belowSearch>
            <p-form>
                <b-row>
                    <b-col>
                        <p-select
                            label="Show"
                            v-model="filters.returnOnlyOpenRecords"
                            :options="searchOptions"
                        />
                    </b-col>
                    <b-col>
                        <p-datepicker
                            label="Start Date"
                            vid="termsStartDate"
                            v-model="filters.startDate"
                        />
                    </b-col>
                    <b-col>
                        <p-datepicker
                            label="End Date"
                            v-model="filters.endDate"
                            rules="dateGreaterOrEqual:@termsStartDate"
                            is-end-date
                        />
                    </b-col>
                </b-row>
            </p-form>
        </template>
    </p-search-screen>
</template>

<script>
import AuthorListReport from '@/views/Reports/Terms/AuthorList.vue';
import SearchStorage from '@/components/mixins/SearchFilterStorage.js';

export default {
    mixins: [SearchStorage],
    data() {
        return {
            filterName: 'TermsFilter',
            filters: {
                automatic: "",
                perPage: 100,
                sortBy: 'termId',
                sortDesc: true,
                searchBy: 'All',
                startDate: null,
                endDate: null,
                returnOnlyOpenRecords: true
            },
            filterBy: ['All', 'Name', 'Description', 'Campus'],
            searchOptions: [
                { value: null, text: 'All Terms' },
                { value: true, text: 'Open Terms' },
                { value: false, text: 'Closed Terms' }
            ],
            fields: [
                {
                    key: 'name',
                    sortable: true
                },
                {
                    key: 'description',
                    sortable: true
                },
                {
                    key: 'campus',
                    sortable: true
                },
                {
                    key: 'status',
                    sortable: true
                },                
                {
                    key: 'publishOnline',
                    label: 'Online Sharing',
                    sortable: true,
                    disabled: true
                },
                {
                    key: 'termId',
                    hidden: true
                }
            ]
        };
    },
    components: {
        AuthorListReport
    },
    methods: {
        showAuthorList() {
            this.$bvModal.show('exportAuthorListModal');
        }
    }
};
</script>
<style scoped></style>
